import type { PropsWithChildren } from 'react'
import React, { forwardRef } from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { RadioButtonCheckmark } from '@/components/ui/RadioButtonCheckmark'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import type { IBaseRadioButtonProps } from './types'
import './styles.scss'

const BaseRadioButton = forwardRef<HTMLInputElement, PropsWithChildren<IBaseRadioButtonProps>>((props, ref) => {
  const {
    label,
    onFocus,
    onBlur,
    onChange,
    labelId,
    children,
    className = '',
    CustomLabel,
    disabled,
    labelTextClassName,
    controlStyle,
    sizeMobile,
    name,
    checked,
    value,
    error,
    checkmarkLabel,
  } = props

  const { isMobile } = useDeviceType()

  const size = isMobile && sizeMobile ? sizeMobile : null

  return (
    <label className={classNames('customRadio', className)}>
      <input
        type="radio"
        name={name}
        checked={checked}
        value={value}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        ref={ref}
      />
      <RadioButtonCheckmark
        size={size}
        error={error}
        controlStyle={controlStyle}
        className={classNames('customRadio__checkmark', size && `customRadio__checkmark_${size}`)}
      >
        {checkmarkLabel}
      </RadioButtonCheckmark>
      <span className={classNames('customRadio__label', labelTextClassName)}>
        {CustomLabel || label || (labelId && <FormattedMessage id={labelId} />)}
      </span>
      {children}
    </label>
  )
})

export default BaseRadioButton
